import React, { useEffect, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Network from './Requests';
import Users from './Users';
import AddingProjectTemplate from './AddingProjectTemplate';
import { setLoader } from '../store/reducers/preloaderSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  setFolderStore,
  setProductStore,
  setSourceStore,
  setPhone,
} from '../store/reducers/saveGuids';
import { useTranslation } from "react-i18next";

const DescriptionProject = (props) => {
  const { t } = useTranslation();

  const [openTemplate, setOpenTemplate] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [source, setSource] = React.useState([]);
  const [type, setType] = React.useState([]);
  const companyId = useSelector((state) => state.project.companyId);
  const calculationGuid = useSelector((state) => state?.variant?.current?.calculationGuid);
  const dispatch = useDispatch();

  const getData = async () => {
    if (props.current && Object.keys(props.current).length !== 0) {
      try {
        const product = await new Network().GetProductTypes();
        const source = await new Network().GetSourceTypes();
        const sourceName = source?.find((item) => item.id === props.current.idSourceType);
        const productName = product?.find((item) => item.id === props.current.idProductType);

        setType(productName?.name || '');
        setSource(sourceName?.name || '');
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  const getGroups = async () => {
    if (companyId != 'null' && companyId != undefined && props.current?.forDisplayTape == false) {
      let folders = await new Network().GetGroups(companyId, props.current.projectGuid);
      dispatch(setFolderStore(folders));
    }
  };

  useEffect(() => {
    getData();
    localStorage.setItem('phone', props?.current?.phoneNumber);
    dispatch(setPhone(props?.current?.phoneNumber));
  }, [props.current]);

  useEffect(() => {
    getGroups();
  }, [companyId, calculationGuid, props.current]);

  const chatCreatedDateField =
    props.current?.requestDate != null
      ? `${t("description.chatCreatedDate")}: ` +
        props.current.requestDate.substring(0, 10) +
        ' ' +
        props.current.requestDate.substring(11, 19)
      : null;

  const orderingDateField =
    props.current?.orderDate != null
      ? `${t("description.orderDate")}: ` + props.current.orderDate.substring(0, 10)
      : null;

  const expirationDateField =
    props.current?.expirationDate != null
      ? `${t("description.expirationDate")}: ` + props.current.expirationDate.substring(0, 10)
      : null;

  const completeDateField =
    props.current?.orderCompletionDate != null
      ? `${t("description.completeDate")}: ` + props.current.orderCompletionDate.substring(0, 10)
      : null;

  const archiveDateField =
    props.current?.archivedDate != null
      ? `${t("description.archiveDate")}: ` + props.current.archivedDate.substring(0, 10)
      : null;

  const projectFields = [
    props.current?.projectNameOriginal,
    props.current?.orderNumber,
    props.current?.address,
    props.current?.customerFullName,
    props.current?.phoneNumber,
    props.current?.clientEmail,
    props.current?.amoCRMLink,
    source,
    type,
    props.current?.sum,
    chatCreatedDateField,
    orderingDateField,
    expirationDateField,
    completeDateField,
    archiveDateField,
    props.current?.description,
    props.current?.feedback,
    props.current?.workCosts,
    props.current?.materialCosts,
    props.current?.costsNote,
    props.current?.currentCRMGroup?.name,
  ];

  const numberOfItems = showMore ? projectFields.length : 4;

  const handleClose = () => {
    props.close();
    setActiveStep(0);
  };
  const handleShowMoreClick = () => {
    setShowMore(!showMore);
  };
  const handleOpenTemplate = () => {
    setActiveStep(1);
  };

  const back = () => {
    setActiveStep(0);
    setOpenTemplate(true);
  };

  const handleCloseTemplate = () => {
    setOpenTemplate(false);
  };

  const saveProject = (
    name,
    number,
    address,
    fullName,
    phone,
    clientEmail,
    amoLink,
    source,
    productType,
    sum,
    requestDate,
    orderDate,
    expirationDate,
    orderCompletionDate,
    archivedDate,
    feedback,
    descr,
    workCosts,
    materialCosts,
    costsNote,
    selectFolder,
  ) => {
    dispatch(setLoader(true));
    new Network()
      .Update(
        props.current.projectGuid,
        name,
        number,
        address,
        fullName,
        phone,
        clientEmail,
        amoLink,
        source,
        productType,
        sum,
        new Date(requestDate),
        new Date(orderDate),
        new Date(expirationDate),
        new Date(orderCompletionDate),
        new Date(archivedDate),
        feedback,
        descr,
        workCosts,
        materialCosts,
        costsNote,
        selectFolder,
        companyId,
      )
      .then((result) => {
        props.onUpdateProject(result, props.current.projectGuid);
        setOpenTemplate(false);
        dispatch(setLoader(false));
      });
  };

  function getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return (
          <>
            <div className="top-panel">
              <p onClick={handleClose} className="top-panel--close">
                {t("back")}
              </p>
              <p onClick={handleOpenTemplate} className="top-panel--edit-name">
                {t("edit")}
              </p>
            </div>
            <div className="pr-descr-title">
              <div
                className="pr-descr-photo"
                style={{
                  backgroundImage: `url("${props.current?.projectSmallPicturePath}")`,
                }}></div>
              <div className="pr-descr-project-name pr-descr-project-name--info">
                {props.current?.name?.slice(0, 350)}
              </div>
            </div>
            <div className="pr-descr-items">
              {projectFields.slice(0, numberOfItems).map((item, idx) => {
                if (item != null && item != '') {
                  return <div key={idx} className="pr-descr-item pr-descr-item--edit">{item}</div>;
                }
              })}
            </div>

            <div className="pr-users-info">
              <div
                className={'pr-descr-share pr-descr-share--info ' + (showMore ? 'active' : '')}
                onClick={() => handleShowMoreClick()}>
                {t("description.more")}
              </div>
              <Users typeView="large" current={props.current} />
            </div>
          </>
        );
      case 1:
        return (
          <AddingProjectTemplate
            current={props.current}
            show={true}
            close={handleCloseTemplate}
            save={saveProject}
            slice={true}
            back={back}
            step={activeStep}
            open={openTemplate}
          />
        );
      default:
        return t("unknownStep");
    }
  }

  return (
    <Dialog open={props.show} keepMounted onClose={handleClose}>
      <DialogContent style={{ paddingLeft: 0, paddingRight: 0 }}>
        {getStepContent(activeStep)}
      </DialogContent>
    </Dialog>
  );
};

export default DescriptionProject;
